import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Megapack después de comprar?',
  a: 'Inmediatamente después de confirmar el pago recibís un mail con el acceso a todos los PDFs. En menos de 5 minutos tenés todo disponible para descargar y empezar a usar.'
}, {
  q: '¿Sirve si no tengo ningún problema activo todavía?',
  a: 'Absolutamente. De hecho, el mejor momento para tener estas herramientas es antes de necesitarlas. Muchos compradores lo usan como guía preventiva para saber qué no firmar, qué revisar y cómo protegerse antes de que surja un problema.'
}, {
  q: '¿Los tomos están actualizados con la legislación vigente en Argentina?',
  a: 'Sí. Todo el contenido está basado en la normativa vigente en Argentina al momento de la publicación, incluyendo la ley de alquileres, normativas del BCRA, PMO actualizado y legislación laboral.'
}, {
  q: '¿Necesito saber de derecho para entender el contenido?',
  a: 'Para nada. Está escrito en lenguaje humano, sin tecnicismos. Si encontrás algún término que no entendés, el Bono 2 (Glosario ciudadano) lo explica en dos líneas. El objetivo es que cualquier persona pueda usarlo sin formación previa.'
}, {
  q: '¿Los 4 bonos están en las dos ofertas?',
  a: 'Sí. Los 4 bonos (kit de cartas, glosario, mapa de organismos y calculadora de plazos) están incluidos en ambas ofertas sin costo adicional. La diferencia entre las dos es que DEFENDETE TOTAL incluye los Tomos 7 y 8 que son exclusivos de esa oferta.'
}, {
  q: '¿Qué diferencia tiene con buscar información en Google?',
  a: 'Google te da información general que muchas veces no aplica a tu caso concreto, no tiene un orden lógico de acción y no te da herramientas listas para usar. DEFENDETE te da un protocolo de pasos concretos, cartas modelo ya redactadas y checklists para tu situación específica. La diferencia entre leer sobre natación y tener la tabla de entrenamiento armada.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí, 7 días completos sin preguntas. Si por cualquier motivo no quedás conforme, te devolvemos el 100% de lo que pagaste. La tasa de devoluciones es menor al 1%.'
}, {
  q: '¿Por qué elegir DEFENDETE TOTAL y no la oferta básica?',
  a: 'DEFENDETE TOTAL agrega los dos tomos más estratégicos del Megapack: el de los 30 errores (que te muestra exactamente cómo no arruinar un reclamo válido) y el de cuándo necesitás un abogado (que te protege de gastar en honorarios cuando podés resolverlo solo, y de pagar de más cuando sí lo necesitás). Por $8.000 más obtenés la capa de protección más importante.'
}];
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-12 md:py-[70px] px-5 bg-white" data-id="element-20">
      <div className="max-w-[860px] mx-auto" data-id="element-21">
        <div className="text-[11px] font-extrabold tracking-[0.14em] uppercase text-blue mb-2" data-id="element-22">
          Dudas comunes
        </div>
        <h2 className="font-display text-[clamp(28px,6vw,52px)] text-navy mb-6 md:mb-9 leading-tight" data-id="element-23">
          Preguntas frecuentes
        </h2>

        <div className="max-w-[720px] mx-auto" data-id="element-24">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="border-b border-border" data-id="element-25">
                <button className="w-full text-left py-4 md:py-5 flex justify-between items-center gap-4 text-[14px] md:text-[15px] font-bold text-navy hover:text-blue transition-colors" onClick={() => toggleFaq(i)} data-id="element-26">
                  {faq.q}
                  <motion.div animate={{
                rotate: isOpen ? 45 : 0
              }} transition={{
                duration: 0.2
              }} className="text-blue flex-shrink-0" data-id="element-27">
                    <Plus size={18} data-id="element-28" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-29">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2
              }} className="overflow-hidden" data-id="element-30">
                      <div className="pb-4 md:pb-5 text-[13px] md:text-[14px] text-text-muted leading-relaxed" data-id="element-31">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}